
export default {
  props: {

    /**
     * @values colors
     */
    background: {
      /** @type {AlturaColors} */
      type: String,
      default: ''
    },

    center: {
      type: Boolean
    },

    screen: {
      type: Boolean,
      default: false
    }
  }
};
